<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <template v-if="edicao && novo_contato">
                            <h5 class="modal-title">{{ titulo ? titulo : 'Contatos' }}: {{ edicao.nome_paciente }}
                                <span class="text-muted ml-2" v-if="edicao.id_atendimento">
                                    #{{ edicao.id_atendimento }}
                                </span>

                                <span v-else-if="edicao.model && edicao.model.id" class="badge badge-secondary ml-2">
                                    {{ edicao.model.id }}
                                </span>

                                <span v-if="id_marcacao" class="badge badge-secondary ml-2">
                                    M{{ id_marcacao }}
                                </span>
                            </h5>
                        </template>
                        <template v-else>
                            <h5 class="modal-title">
                                {{ titulo ? titulo : 'Contatos' }}...
                            </h5>
                        </template>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="!edicao || !novo_contato">
                            <az-empty-state />
                        </template>

                        <template v-else-if="novo_contato">
                            <div class="alert alert-dark d-flex justify-content-between" v-if="marcacao_infusao">
                                <div>
                                    <div class="lead">{{ marcacao_infusao.procedimento.search }}</div>
                                    <div v-if="marcacao_infusao.infusao">{{ marcacao_infusao.infusao.st_titulo }}
                                        <span v-if="marcacao_infusao.unidade_operacao && marcacao_infusao.unidade_operacao.st_sigla" class="badge badge-light ml-2" title="Unidade">
                                            {{ marcacao_infusao.unidade_operacao.st_sigla }}
                                        </span>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <div v-if="marcacao_infusao.id_atendimento">
                                        <strong>#{{ marcacao_infusao.id_atendimento }}</strong>
                                    </div>
                                    <div v-else>
                                        <strong>M{{ marcacao_infusao.id_marcacao }}</strong>
                                    </div>
                                    <div v-if="marcacao_infusao.dt_inicio">
                                        {{ $util.getFormatDate(marcacao_infusao.dt_inicio) }}
                                    </div>
                                    <div v-if="marcacao_infusao.in_qt_dia && marcacao_infusao.in_qt_ciclo">
                                        <i class="fa-solid fa-arrows-spin mr-2"></i>
                                        C{{ marcacao_infusao.in_qt_ciclo }} / D{{ marcacao_infusao.in_qt_dia }}
                                    </div>
                                </div>

                                <pre v-if="false">{{ marcacao_infusao }}</pre>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-8">
                                    <template v-if="pode_alterar">
                                        <az-input
                                            v-if="lista_status"
                                            :validate="validate"
                                            type="select" 
                                            optionsMode="json"
                                            :optionsList="lista_status_exibir"
                                            optionsData="id_contato_status"
                                            placeholder="Selecione o status..."
                                            v-model="novo_contato.id_contato_status" 
                                            @input="ver_obs_padrao()"/>

                                        <az-input
                                            v-else
                                            :validate="validate"
                                            type="select" 
                                            optionsMode="aql"
                                            service="contato_status.index"
                                            :optionsParm="{ model: edicao.model.type, ativos: true }"
                                            :optionsName="'cont_status_' + edicao.model.type"
                                            optionsData="id_contato_status"
                                            placeholder="Selecione o status..."
                                            v-model="novo_contato.id_contato_status" />

                                        <template v-if="!!novo_contato.id_contato_status">

                                            <az-input
                                                required 
                                                :validate="validate"
                                                label="Comentários"
                                                type="textarea"
                                                rows="5"
                                                v-model="novo_contato.st_observacoes" />

                                            <az-input
                                                v-if="status_selecionado && status_selecionado.fl_informar_data"
                                                required 
                                                :validate="validate"
                                                label="Referência"
                                                type="date"
                                                v-model="novo_contato.dt_referencia" />

                                            <div v-if="edicao && edicao.model && edicao.model.type == 'tarefa' && edicao.id_tarefa && novo_contato.fl_feita !== null">
                                                <az-input 
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Tarefa concluída"
                                                    v-model="novo_contato.fl_feita" />
                                            </div>

                                        </template>
                                    </template>

                                    <template v-else>
                                        <div class="alert alert-info">
                                            Acesso para visualização.
                                        </div>
                                    </template>

                                    <template v-if="edicao && edicao.contatos && edicao.contatos.length > 0">

                                        <hr> 

                                        <!-- Nav tabs -->
                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                            <li class="nav-item" role="presentation">
                                                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                                                    Histórico
                                                    <span class="badge badge-secondary ml-1" v-if="edicao && edicao.contatos">{{ edicao.contatos.length }}</span>
                                                </a>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false" v-if="lista_pendencias.length">
                                                    Pendências
                                                    <span class="badge badge-secondary ml-1" v-if="lista_pendencias.length">{{ lista_pendencias.length }}</span>
                                                </a>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                <a class="nav-link" id="tarefas-tab" data-toggle="tab" href="#tarefas" role="tab" aria-controls="tarefas" aria-selected="false" v-if="tarefas && tarefas.length">
                                                    Tarefas
                                                    <span class="badge badge-secondary ml-1">{{ tarefas_feitas.length }}/{{ tarefas.length }}</span>
                                                </a>
                                            </li>
                                        </ul>

                                        <!-- Tab panes -->
                                        <div class="tab-content">
                                            <!-- Histórico -->
                                            <div class="tab-pane active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                                <ul class="list-group small mt-3">
                                                    <li class="list-group-item d-flex justify-content-between" v-for="(contato, idx) in edicao.contatos" :key="idx"
                                                        :class="!idx ? 'list-group-item-info' : ''">

                                                        <div>
                                                            <span class="mr-3">{{ contato.contato_status.search }}</span>
                                                            <span class="text-muted">{{ contato.usuario.st_login }} em {{ $util.getFormatDate(contato.created_at) }} {{ contato.created_at.substr(11,5) }}</span>
                                                            <div v-if="contato.dt_referencia">Referência: {{ $util.getFormatDate(contato.dt_referencia) }}</div>
                                                            <div style="white-space: pre-wrap;">{{ contato.st_observacoes }}</div>

                                                            <!-- Pendente -->
                                                            <template v-if="contato.fl_pendente === true">
                                                                <div class="strong mt-2">
                                                                    <i class="fa-solid fa-circle-exclamation text-warning fa-fw mr-2"></i>Pendente
                                                                </div>
                                                            </template>

                                                            <!-- Resolvido -->
                                                            <template v-if="contato.fl_pendente === false">
                                                                <div class="strong mt-2">
                                                                    <i class="fa-solid fa-circle-check text-success fa-fw mr-2"></i>
                                                                    {{ $util.getFormatDate(contato.dt_solucao) }} {{ contato.dt_solucao.slice(11,16) }}, {{ contato.usuario_solucao ? contato.usuario_solucao.st_login : '' }}
                                                                    <div v-if="contato.st_solucao" class="mt-1">
                                                                        <div style="white-space: pre-wrap;">{{ contato.st_solucao }}</div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>

                                                        <div class="text-right">
                                                            <span v-if="contato.marcacao" :class="( id_marcacao && ( contato.marcacao.id_marcacao == id_marcacao ) ) ? 'font-weight-bold' : ''">
                                                                <div v-if="contato.marcacao.id_atendimento">
                                                                    #{{ contato.marcacao.id_atendimento}}
                                                                </div>
                                                                <div v-else>
                                                                    M{{ contato.marcacao.id_marcacao}}
                                                                </div>

                                                                <div v-if="contato.marcacao.dt_inicio">
                                                                    {{ $util.getFormatDate(contato.marcacao.dt_inicio) }}
                                                                </div>
                                                            </span>
                                                        </div>
                                                        
                                                    </li>
                                                </ul>
                                            </div>

                                            <!-- Pendências -->
                                            <div class="tab-pane" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                                                <table class="table table-sm table-hover mt-3 small">
                                                    <thead>
                                                        <tr>
                                                            <td></td>
                                                            <td>Data</td>
                                                            <td>Responsável</td>
                                                            <td>Status</td>
                                                            <td>Descrição</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(pendencia, idx) in lista_pendencias" :key="idx" :class="pendencia.contato_status.st_color ? 'table-' + pendencia.contato_status.st_color : ''">
                                                            <td>
                                                                <input type="checkbox" v-model="pendencia.ok" :disabled="!!novo_contato.id_contato_status"/>
                                                            </td>
                                                            <td>
                                                                {{ $util.getFormatDate(pendencia.created_at) }}
                                                            </td>
                                                            <td>{{ pendencia.usuario.st_login }}</td>
                                                            <td>{{ pendencia.contato_status.search }}</td>
                                                            <td>
                                                                <div style="white-space: pre-wrap;">{{ pendencia.st_observacoes }}</div>
                                                                <textarea class="form-control form-control-sm mt-1" rows="2" v-model="pendencia.st_solucao" v-if="pendencia.ok"
                                                                    placeholder="Observações..."></textarea>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <!-- Tarefas -->
                                            <div class="tab-pane" id="tarefas" role="tabpanel" aria-labelledby="tarefas-tab">

                                                <table class="table table-sm table-hover mt-3 small">
                                                    <thead>
                                                        <tr>
                                                            <td></td>
                                                            <td>#</td>
                                                            <td>Serviço</td>
                                                            <td>Descrição</td>
                                                            <td>Criação</td>
                                                            <td>Responsável</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(tarefa, idx) in tarefas" :key="idx" :class="tarefa.fl_feita ? 'table-success' : 'table-primary'">
                                                            <td>
                                                                <i class="fa fa-check-circle text-success fa-fw" aria-hidden="true" v-if="tarefa.fl_feita"></i>
                                                                <i class="fa fa-question-circle text-primary fa-fw" aria-hidden="true" v-else></i>
                                                            </td>
                                                            <td>#{{ tarefa.id_tarefa }}</td>
                                                            <td>{{ tarefa.servico ? tarefa.servico.search : '' }}</td>
                                                            <td>{{ tarefa.st_descricao }}</td>
                                                            <td>
                                                                {{ tarefa.criador ? tarefa.criador.st_login : '' }}
                                                                <div class="text-muted" v-if="tarefa.created_at">
                                                                    {{ $util.getFormatDate(tarefa.created_at) }} {{ tarefa.created_at.slice(11,16) }}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {{ tarefa.usuario ? tarefa.usuario.st_login : '' }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>

                                    </template>

                                    <template v-if="false">
                                        <pre class="alert alert-danger mt-3">{{ novo_contato }}</pre>
                                        <pre class="alert alert-warning">{{ status_selecionado }}</pre>
                                    </template>
                                </div>
                                <div class="col col-12 col-md-4">
                                    <slot name="info"></slot>

                                    <div v-if="marcacao_infusao && marcacao_infusao.atendimento && marcacao_infusao.atendimento.atendimento_procedimentos && marcacao_infusao.atendimento.atendimento_procedimentos.length">
                                        <ul class="list-group small mt-3">
                                            <li class="list-group-item d-flex justify-content-between" v-for="(atp, idx) in marcacao_infusao.atendimento.atendimento_procedimentos" :key="idx">
                                                <div>{{ atp.procedimento.search }}</div>
                                                <div>
                                                    <i class="fa-solid fa-signature text-success mr-2" v-if="atp.laudo && atp.laudo.doc_certificado" title="Assinado com Certificado Digital"></i>
                                                    <span v-if="atp.laudo && atp.laudo.status_laudo">
                                                        <span :class="atp.laudo.status_laudo.st_color ? 'badge badge-' + atp.laudo.status_laudo.st_color : 'badge badge-secondary'">
                                                            {{ atp.laudo.status_laudo.st_status_laudo }}
                                                        </span>
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_contato()" v-if="pode_alterar && novo_contato">
                            <span v-if="novo_contato.id_contato_status">
                                Registrar {{ titulo ? titulo : 'Contato' }}
                            </span>
                            <span v-else>
                                Atualizar
                            </span>
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Consulta dos Contatos -->
        <div class="modal fade" :id="'consulta' + modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <h5 class="modal-title">
                                {{ titulo ? titulo : 'Contatos' }}...
                            </h5>
                        </h5>
                        <button type="button" class="close" aria-label="Close" @click="fechar('consulta' + modal_name)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="!lista || !lista.length">
                            <az-empty-state />
                        </template>

                        <template v-else>
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(contato, idx) in lista" :key="idx"
                                    :class="!idx ? 'list-group-item-info' : ''">
                                    <span class="mr-3"><strong>{{ contato.contato_status.search }}</strong></span>
                                    <span class="text-muted">{{ contato.usuario.st_login }} em {{ $util.getFormatDate(contato.created_at) }} {{ contato.created_at.substr(11,5) }}</span>
                                    <div v-if="contato.dt_referencia">Referência: {{ $util.getFormatDate(contato.dt_referencia) }}</div>
                                    <div style="white-space: pre-wrap;">{{ contato.st_observacoes }}</div>
                                </li>
                            </ul>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar('consulta' + modal_name)">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../util/AzSubmit.vue';
import AzInput from '../shared/forms/AzInput.vue';
import AzEmptyState from '../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            edicao: null, 
            validate: false,
            novo_contato: null, 
            lista: null, 
            chave: "", 
            marcacao_infusao: null, 
            tarefas: null, 
        };
    },

    props: ['lista_status', 'titulo', 'extra_parms', 'block_origem', 'id_marcacao', 'id_fila_lead'],

    components: { 
        AzSubmit,
        AzInput, 
        AzEmptyState, 
    },

    computed: { 
        modal_name: function () { 
            return 'contatosModal' + (this.chave ? this.chave : '');
        },

        pode_alterar: function () { 
            return !this.block_origem 
                || !this.edicao
                || !this.edicao.contatos 
                || !this.edicao.contatos.length
                || !this.block_origem.find(item => item == this.edicao.contatos[0].id_contato_status);
        },

        status_selecionado: function() { 
            if ( !this.novo_contato || !this.novo_contato.id_contato_status ) { 
                return null;
            }

            return this.lista_status_exibir.find(item => item.id_contato_status == this.novo_contato.id_contato_status);
        },

        lista_status_exibir: function () { 
            if ( !this.lista_status )
                return [];

            return this.lista_status.filter(item => !isNaN(item.id_contato_status));
        }, 

        lista_pendencias: function () { 
            if ( !this.edicao || !this.edicao.contatos )
                return [];

            return this.edicao.contatos.filter(item => item.fl_pendente);
        },

        tarefas_feitas: function () { 
            if ( !this.tarefas )
                return [];

            return this.tarefas.filter(item => item.fl_feita);
        },

    },

    methods: {
        ver_obs_padrao() { 
            
            let cs = this.lista_status_exibir.find(item => item.id_contato_status == this.novo_contato.id_contato_status);

            if ( cs && cs.st_obs_padrao ) { 
                this.novo_contato.st_observacoes = cs.st_obs_padrao;
            } else { 
                this.novo_contato.st_observacoes = "";
            }

        },

        fechar (modal) { 
            $('#' + modal).modal('hide');
        },

        abrir () { 
            this.validate = false;
            this.novo_contato = null;
            this.edicao = null;
            this.marcacao_infusao = null; 

            $('#' + this.modal_name).modal('show');
        },
        editar (item) { 
            this.validate = false;
            this.novo_contato = null;
            this.marcacao_infusao = null; 
            this.tarefas = null; 

            this.$nextTick(() => { 

                this.novo_contato = { 
                    model_type: item.model.type, 
                    model_id: item.model.id, 
                    id_contato_status: "",
                    st_observacoes: "", 
                    lista: item.lista, 
                    fl_feita: item.id_tarefa ? item.fl_feita : null, 
                };

                this.edicao = _.cloneDeep(item);

                this.$util.load(this, { 
                    service: 'crm',
                    func: 'get_contatos',
                    parms: { 
                        model_type: item.model.type, 
                        model_id: item.model.id, 
                        id_marcacao: this.id_marcacao,
                        id_fila_lead: this.id_fila_lead,
                    },
                    loadTo: res => { 
                        this.edicao.contatos = res.lista;       
                        this.marcacao_infusao = res.marcacao; 
                        this.tarefas = res.tarefas;
                    }
                });
    
                this.$nextTick(() => { 
                    $('#' + this.modal_name).modal('show');
                });

            });
        },

        salvar_contato() { 

            const extra = this.extra_parms ? this.extra_parms : {};
            
            this.$util.atualizar(this, { 
                service: 'crm',
                func: 'save_contato',
                dados: { 
                    ...this.novo_contato,
                    ...extra,
                    id_marcacao: this.id_marcacao,
                    pendencias: this.lista_pendencias.filter(item => item.ok), 
                    id_fila_lead: this.id_fila_lead,
                },
                modal: this.modal_name,
                callback: () => { 
                    this.$emit('refresh', this.novo_contato);
                } 
            });

        },

        visualizar (model_type, model_id, item = null, pode_editar = false) { 

            this.lista = null;
            this.tarefas = null; 

            if ( !pode_editar ) { 
                $('#consulta' + this.modal_name).modal('show');
            }
            

            this.$util.load(this, { 
                service: 'crm',
                func: 'get_contatos',
                parms: { 
                    model_type: model_type, 
                    model_id: model_id,
                    id_marcacao: this.id_marcacao,
                    id_fila_lead: this.id_fila_lead,
                },
                loadTo: res => { 

                    console.log(res);

                    this.tarefas = res.tarefas;

                    if ( pode_editar ) { 
                        let edicao = _.cloneDeep(item);
                        edicao.contatos = res.lista;

                        this.editar(edicao);

                        return;
                    }

                    console.log(res);
                    this.lista = res.lista;
                }
            });

        }

    },

    mounted() { 
        this.chave = this.$util.uuidv4();
    }

}
</script>